import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router';
import AdamQTIPlayer from '../views/Player.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/launch/',
    name: 'Player',
    component: AdamQTIPlayer,
  },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});

export default router;
